module.exports = __webpack_public_path__ + "img/aufWildenGewässern.de2df979.jpg";